<h3 mat-dialog-title *ngIf="this.data.mode == 'Transfer'">Confirm transfer</h3>
<h3 mat-dialog-title *ngIf="this.data.mode == 'Scrap'">Confirm scrap</h3>
<mat-dialog-content>

  <div class="container">


    <div class="row">
      <div class="col">
        <h4 style="text-align:center">From</h4>
      </div>
      <div class="col">

      </div>
      <div class="col">
        <h4 style="text-align:center">To</h4>
      </div>
    </div>
    <hr />

    <div class="row">

      <!-- Left column for locks -->
      <div class="col">
        <ng-container *ngFor="let lock of data.locks">
          <div class="row" style="text-align: center; margin-bottom: 10px;" >
            <div class="col"style="border: 1px solid #ccc; background-color: white; border-radius: 10px; padding-top: 10px;">
              <p>Lock: {{lock.SerialId}}</p>
              <p>{{lock.CurrentHolder || 'No current Location'}}</p>
            </div>
          </div>
        </ng-container>
      </div>

      <!-- Middle column for arrow icon -->
      <div class="col" style="align-self:center;">
        <div class="row justify-content-center align-items-center">
          <mat-icon style="transform:scale(2.4)">trending_flat</mat-icon>
        </div>
      </div>

      <!-- Right column for service guy -->
      <div class="col" style="align-self:center;">
        <div *ngIf="data.mode == 'Transfer'" class="row justify-content-center align-items-center" style="border: 1px solid #ccc; background-color: white; border-radius: 10px; padding-top: 10px;">
            <p>{{data.serviceguy.Firstname}} {{data.serviceguy.Lastname}}</p>
            <p>{{data.serviceguy.Companyname}}</p>
        </div>
        <div *ngIf="data.mode == 'Scrap'" class="row justify-content-center align-items-center" >
          <mat-icon style="transform:scale(3.5)">delete</mat-icon>
        </div>
      </div>
    </div>
  </div>


</mat-dialog-content>
<mat-dialog-actions>
  <button mat-flat-button mat-dialog-close (click)="close()"> Cancel </button>
  <button mat-flat-button color="primary" (click)="confirm()"> Confirm </button>
</mat-dialog-actions>
